module.exports = __webpack_public_path__ + "img/OLDGOD.5f1f11ca.svg";